import {combineReducers} from "redux";
import regulatoryinfo from './regulatoryinfo.reducer';
import regulatorycountry from './regulatoryCountry.reducer';

export default combineReducers({
    regulatoryinfo,
    regulatorycountry,
    
})